import { listLayananKonsumen, listLayananOwner } from "./state"

const mutations = {
	// data
	setListLayananKonsumen: (state, res) => {
		// if (state.listLayananKonsumen.data !== undefined) {
		// 	state.listLayananKonsumen.data = [...state.listLayananKonsumen.data, ...res.data];
		// } else {
		// 	state.listLayananKonsumen = res
		// }
		state.listLayananKonsumen = res
	},
	setListLayananOwner: (state, res) => {
		state.listLayananOwner = res
	},

	// reset
	resetListLayananKonsumen: (state) => {
		state.listLayananKonsumen = listLayananKonsumen()
	},
	resetListLayananOwner: (state) => {
		state.listLayananOwner = listLayananOwner()
	}
}

export default mutations